import React from "react";
import "../assets/css/HeroSpeaker.css";
import speaker from "../assets/imgs/indrajeet.png";



import Header from "./Header";

const HeroSpeaker = () => {
    return (
        <section className="speaker-hero">


            <Header></Header>

            {/* HERO CONTENT */}

            <div className="hero-container">

                <div className="hero-left">

                    <h1>
                        Transformational <br />
                        Educator, Author <br />
                        Speaker
                    </h1>

                    <div className="yellow-line"></div>

                    <p>
                        Indrajeet Patil is a Founder Motivational Speaker, Educational
                        Counsellor, Business Psychologist and Writer with over
                        13 years of experience helping professionals and
                        entrepreneurs transform their mindset, decision making
                        and leadership abilities.
                    </p>

                </div>


                <div className="hero-right">

                    <img src={speaker} alt="Indrajeet Patil" />

                </div>

            </div>


            {/* FEATURED SECTION */}

            <div className="featured">

                <span>FEATURED IN :</span>

                <div className="logos">
                    {/* <span>TED</span> */}
                    <span>Business Forums</span>
                    <span>Leadership Summits</span>
                    <span>Real Estate Conferences</span>
                </div>

            </div>

        </section>
    );
};

export default HeroSpeaker;